import { render, staticRenderFns } from "./MaterialExamSubjectEdit.vue?vue&type=template&id=59db1928&scoped=true&"
import script from "./MaterialExamSubjectEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialExamSubjectEdit.vue?vue&type=script&lang=js&"
import style0 from "./MaterialExamSubjectEdit.vue?vue&type=style&index=0&id=59db1928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db1928",
  null
  
)

export default component.exports